module.exports = __webpack_public_path__ + "static/img/award4.c1e3bff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/award4.jpg
// module id = oFqA
// module chunks = 1